import {
  GetTermsResponse,
  TermsListItem,
} from "../types/terms";
import { apiClient } from "./api";

export interface CheckAgreementResponseDto {
  hasAllTermsResponses: boolean;
  hasAllDatasetsResponses: boolean;
}

export interface UpdateMarketingConsentRequest {
  marketingInfoCollectionAgreement: boolean;
  marketingInfoReceiptAgreement: boolean;
}

export interface UpdateMarketingConsentResponse {
  marketingInfoCollectionAgreement: boolean;
  marketingInfoReceiptAgreement: boolean;
  marketingInfoCollectionAgreedAt: string | null;
}

export const termsService = {
  /**
   * 유저의 약관 동의여부 조회
   */
  async getTerms(): Promise<GetTermsResponse> {
    const response = await apiClient.get<GetTermsResponse>("/terms");
    return response.data;
  },

  /**
   * 약관 리스트 조회 (기존 API)
   */
  async getTermsList(isDatasetTerm?: boolean): Promise<TermsListItem[]> {
    const queryString =
      isDatasetTerm !== undefined ? `?isDatasetTerm=${isDatasetTerm}` : "";
    const response = await apiClient.get<TermsListItem[]>(
      `/terms/list${queryString}`
    );
    return response.data;
  },

  /**
   * 유저의 동의 상태 확인
   */
  async checkAgreementStatus(): Promise<CheckAgreementResponseDto> {
    const response = await apiClient.get<CheckAgreementResponseDto>(
      "/users/agreement/status"
    );
    return response.data;
  },

  /**
   * 마케팅 동의 상태 조회
   */
  async getMarketingConsent(): Promise<UpdateMarketingConsentResponse> {
    const response = await apiClient.get<UpdateMarketingConsentResponse>(
      "/users/marketing-consent"
    );
    return response.data;
  },

  /**
   * 마케팅 동의 상태 업데이트
   */
  async updateMarketingConsent(
    request: UpdateMarketingConsentRequest
  ): Promise<UpdateMarketingConsentResponse> {
    const response = await apiClient.patch<UpdateMarketingConsentResponse>(
      "/users/marketing-consent",
      request
    );
    return response.data;
  },
};
